import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import PRACTICE_SETTINGS from '../../practice/settings';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const ClinicalNotesSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/ClinicalNotes')
);
const FormsSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/Forms')
);
const PatientCommunicationSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/PatientCommunication')
);
const SelfSchedulingSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/SelfScheduling')
);
const BridgePostingSettings = withLazyFallback(
  () => import('components/admin/pages/Practices/Settings/components/BridgePosting/BridgePosting')
);
const TerminalManagement = withLazyFallback(
  () => import('components/admin/pages/Practices/Terminals/TerminalManagement')
);
const AdminPracticeModules = withLazyFallback(
  () => import('components/admin/pages/Practices/Modules')
);
const Roles = withLazyFallback(() => import('components/Roles/Roles'));
const ViewportAdminSettings = withLazyFallback(
  () =>
    import('components/admin/pages/Practices/Viewport/components/PracticeViewport/pages/AdminSettings')
);
const ViewportBilling = withLazyFallback(
  () =>
    import('components/admin/pages/Practices/Viewport/components/PracticeViewport/pages/Billing')
);
const ViewportBillingSettings = withLazyFallback(
  () => import('components/practice/Settings/components/Billing/Billing')
);
const ViewportProviderTable = withLazyFallback(
  () =>
    import('components/admin/pages/Practices/Viewport/components/PracticeViewport/pages/ProviderTable')
);
const ViewportStaff = withLazyFallback(
  () => import('components/admin/pages/Practices/Viewport/components/PracticeViewport/pages/Staff')
);

const VIEWPORT_SETTINGS = PRACTICE_SETTINGS.map((settingsRoute) => ({
  ...settingsRoute,
  children: [
    ...settingsRoute.children
      .filter(
        (child) =>
          child.path !== 'roles' &&
          child.path !== 'billing' &&
          child.path !== 'staff' &&
          child.path !== 'eprescribe' &&
          child.path !== '*'
      )
      .concat([
        { path: 'roles', element: <Roles isAdmin />, handle: { title: 'Roles & permissions' } },
        {
          path: 'billing',
          element: <ViewportBilling />,
          handle: { title: 'Billing' },
          children: [
            { index: true, element: <ViewportBillingSettings /> },
            {
              path: 'providers',
              element: <ViewportProviderTable kind="billing" />,
              handle: { title: 'Billing providers' }
            },
            {
              path: 'facilities',
              element: <ViewportProviderTable kind="facility" />,
              handle: { title: 'Facility providers' }
            }
          ]
        },
        { path: 'staff', element: <ViewportStaff />, handle: { title: 'Staff' } },
        { path: 'terminals', element: <TerminalManagement />, handle: { title: 'Terminals' } },
        { path: 'modules', element: <AdminPracticeModules />, handle: { title: 'Modules' } }
      ]),
    {
      element: <ViewportAdminSettings />,
      children: [
        {
          path: 'display-settings',
          element: <FormsSettings />,
          handle: { title: 'Display settings' }
        },
        {
          path: 'patient-communication',
          element: <PatientCommunicationSettings />,
          handle: { title: 'Patient communication' }
        },
        {
          path: 'myrelay',
          element: <BridgePostingSettings />,
          handle: { title: 'MyRelay' }
        },
        {
          path: 'clinical-notes',
          element: <ClinicalNotesSettings />,
          handle: { title: 'Clinical notes' }
        },
        {
          path: 'self-scheduling-steps',
          element: <SelfSchedulingSettings />,
          handle: { title: 'Self scheduling steps' }
        }
      ]
    },
    { path: '*', element: <NotFound /> }
  ]
}));

export default VIEWPORT_SETTINGS;
